// Types e defaults compartilhados pelos sub-componentes de Comercial / Propostas.
// Extraído de ComercialPropostas.tsx durante refactor topológico.

export interface PropostaGerada {
  id: string;
  proposta_id: number;
  composicao_id: string | null;
  modelo_id: string;
  versao: number;
  revisao?: number;
  numero_proposta?: string;
  tipo?: string;
  titulo: string;
  status: string;
  negocio_titulo: string;
  modelo_nome: string;
  link_hash?: string | null;
  link_publicado_em?: string | null;
  aceite_em?: string | null;
  aceite_nome?: string | null;
  criado_em: string;
  atualizado_em: string;
}

export interface Modelo {
  id: string;
  nome: string;
  tipo: string | null;
  ativo: boolean;
  conteudo?: string;
  criado_em: string;
  atualizado_em: string;
}

export const DADOS_DEFAULT = {
  titulo: '', prazo_entrega: '',
  descricao_tecnica: '', entregaveis: '', cronograma: '', condicoes_gerais: '',
  itens_nao_integram: '', responsabilidades_contratada: '', responsabilidades_contratante: '',
  medicoes: '', condicoes_pagamento: '',
  // percentual/valor_str convivem: o editor grava os dois; o valor_str (R$
  // digitado) manda no documento e no plano financeiro (handlers/parcelasUtil.js)
  //
  // KICKOFF (2026-08-20) — `prazo` é o texto que o CLIENTE lê no PDF ("Na
  // assinatura", "30 dias após a entrega"); ele nunca foi parseado. Quem manda
  // na DATA da parcela são os dois números abaixo, lidos por
  // handlers/contratos.js ao iniciar o contrato:
  //   nota_fiscal_emissao = data_assinatura + dias_apos_assinatura
  //   data_vencimento     = nota_fiscal_emissao + prazo_pagamento_dias
  // Antes disso, os dois campos não existiam no frontend e TODA parcela nascia
  // com emissão no dia da venda e vencimento em +30.
  parcelas: [] as Array<{
    descricao: string;
    percentual: number | string;
    valor_str?: string;
    prazo: string;
    dias_apos_assinatura?: number | string | null;
    prazo_pagamento_dias?: number | string | null;
    fixada?: boolean;
  }>,
};

// Default do prazo de pagamento de uma parcela nova (dias entre a emissão da NF
// e o vencimento). Espelha PRAZO_PAGAMENTO_DEFAULT em handlers/contratos.js.
export const PRAZO_PAGAMENTO_DEFAULT = 30;
